.btn {
  composes: btn from '../utils.module.css';
  padding: 0.5rem;
  font-size: 0.75em;
}

.btnLike {
  composes: btnLike from '../utils.module.css';
  height: 1.625rem;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,
    rgba(0, 0, 0, 0.1) 0px 4px 11px;
}
